import React from "react";
import moment from "moment";
import PropTypes from "prop-types";
import cn from "classnames";
import { useTranslation } from 'react-i18next';

import { formatDate, formatTime } from "../../../utils/formatDate";

import styles from "./dataTypes.less";

const DateField = props => {
  const { i18n: { language } } = useTranslation();
  moment.locale(language);
  let date = moment(new Date(props.value));
  if (props.value) {
    return (
      <span className={cn(props.containerClassName, styles.simpleField)}>
        {formatDate(date, language)}
        &nbsp;
        {
          <span className={styles.extraData}>
            {!!props.config.get("time")
              ? formatTime(date)
              : date.format("dd").toUpperCase()}
          </span>
        }
      </span>
    );
  } else {
    return null;
  }
};

DateField.propTypes = {
  value: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  config: PropTypes.object
};

export default DateField;
